import NRHashFileStyles from './NRHashFile.styles';
import makeStyles from '@mui/styles/makeStyles';
import NRKeyValueDataDisplay from '../../NRKeyValueDataDisplay/NRKeyValueDataDisplay';
const useStyles = makeStyles(NRHashFileStyles);

function NRHashFile({ file }) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <NRKeyValueDataDisplay
        showDash={true}
        keyWidth={'auto'}
        minWidth={32}
        valueMaxWidth={450}
        dataKey={`MD5`}
        value={file.digest?.md5}
        hasCopy={true}
      />
      <NRKeyValueDataDisplay
        hasCopy={true}
        showDash={true}
        keyWidth={'auto'}
        minWidth={32}
        valueMaxWidth={450}
        dataKey={`SHA1`}
        value={file.digest?.sha1}
      />
      <NRKeyValueDataDisplay
        hasCopy={true}
        showDash={true}
        keyWidth={'auto'}
        minWidth={32}
        valueMaxWidth={450}
        dataKey={`SHA256`}
        value={file.digest?.sha256}
      />
    </div>
  );
}

export default NRHashFile;
